export default "__VITE_ASSET__DZNeM0vZ__"